// extracted by mini-css-extract-plugin
export var layoutContainer = "_9h-0";
export var layoutContainerNoRounding = "_9h-6";
export var layoutContainerOpen = "_9h-5";
export var layoutContainerResizing = "_9h-1";
export var mainContent = "_9h-2";
export var resizeDivider = "_9h-3";
export var slidePanel = "_9h-4";